import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/InternDashboard.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
localStorage.setItem("certNo", "CVEY260201");
const InternDashboard = () => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState({});
  useEffect(() => {
    const fetchAssignments = async () => {
      const internEmail = localStorage.getItem('internEmail');
      if (!internEmail) {
        navigate('/'); // redirect if not logged in
        return;
      }

      try {

        const response = await axios.get(`/api/intern/status/${internEmail}`);
        if (response.status === 200 && response.data) {
          const assignmentArray = ["assignment1", "assignment2", "assignment3", "assignment4"].map((key, index) => ({
            id: index + 1,
            key,
            name: `Assignment ${index + 1}`,
            status: response.data[key] || 'Pending',
          }));
          setAssignments(assignmentArray);
        } else {
          console.error('Error: unexpected response', response);
        }
      } catch (err) {
        console.error('Error fetching assignments:', err);
      } finally {
        setLoading(false);
      }
    };
    const fetchUploadedAssignments = async () => {
      try {

        const internEmail = localStorage.getItem("internEmail");

        const res = await axios.get(
          `/api/admin/assignments/${internEmail}`
        );

        setUploadedFiles(res.data);

      } catch (err) {
        console.error("Error fetching uploaded files:", err);
      }
    };
    fetchAssignments();
    fetchUploadedAssignments(); // ✅ ADD THIS
  }, [navigate]);

  const allCompleted = assignments.length > 0 && assignments.every(a => a.status === 'Completed');

  const handleLogout = () => {
    localStorage.removeItem('internEmail');
    navigate('/');
  };
  // 🔥 Generate Certificate
  const generateCertificate = async () => {
    try {
      const certNo = localStorage.getItem("certNo");

      const res = await axios.get(
        `https://cveysolutions.in/api/certificate/${certNo}`
      );

      const data = res.data;

      setCertificateData(data);

      // Wait for React to render
      setTimeout(async () => {
        await downloadPDF();
      }, 800);

    } catch (err) {
      console.error(err);
      alert("Error generating certificate");
    }
  };

  // 🔥 Download PDF
  const downloadPDF = async () => {
    const element = document.getElementById("certificate");

    const canvas = await html2canvas(element, { useCORS: true });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("landscape");
    pdf.addImage(imgData, "PNG", 10, 10, 280, 150);

    pdf.save(`${certificateData.student_name}_certificate.pdf`);
  };
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <h2>Loading your dashboard...</h2>
      </div>
    );
  }
  const BASE_URL = window.location.origin.includes("localhost")
    ? "http://localhost:5000"
    : "https://cveysolutions.in";
  return (
    <div className="intern-dashboard-container">
      <button className="logout-btn" onClick={handleLogout}>Logout</button>

      <div className="dashboard-card">
        <h1 className="title">Welcome, Intern! 👋</h1>
        <p className="subtitle">Track your assignments and progress here.</p>
        <div className="important-note">
          <strong>⚠ Important:</strong>
          <p>
            After completing all assignments, please send your Jupyter Notebook to the support email (
            <a href="mailto:support@cveysolutions.in" className="support-email">
              support@cveysolutions.in
            </a>
            ) before the deadline for approval.
          </p>
        </div>
        <div className="assignments-list">
          {assignments.map((assignment, index) => {
            const file = uploadedFiles[assignment.key];

            if (!file) {
              return (
                <div
                  key={assignment.id}
                  className={`assignment-item ${index % 2 === 0 ? 'alt-bg-1' : 'alt-bg-2'}`}
                >
                  <span className="assignment-name">{assignment.name}</span>

                  <button className={`status-button ${assignment.status.toLowerCase()}`}>
                    {assignment.status}
                  </button>

                  <span className="no-file">Not yet uploaded</span>
                </div>
              );
            }

            return (
              <div
                key={assignment.id}
                className={`assignment-item ${index % 2 === 0 ? 'alt-bg-1' : 'alt-bg-2'}`}
              >
                <span className="assignment-name">{assignment.name}</span>

                <button className={`status-button ${assignment.status.toLowerCase()}`}>
                  {assignment.status}
                </button>
                <a
                  href={`${BASE_URL}/uploads/${file}`}
                  download
                  className="view-btn"
                >
                  Download
                </a>
              </div>
            );
          })}
        </div>

        <button
          className={`generate-certificate-btn ${allCompleted ? 'enabled' : 'disabled'}`}
          disabled={!allCompleted}
          onClick={generateCertificate}
        >
          Generate Certificate
        </button>
      </div>
      {certificateData && (
        <div
          id="certificate"
          style={{
            width: "1000px",
            padding: "40px",
            border: "10px solid black",
            textAlign: "center",
            background: "#fff",
            position: "absolute",
            left: "-9999px"
          }}
        >
          <h1 style={{ fontSize: "40px" }}>CERTIFICATE</h1>

          <p>This is to certify that</p>

          <h2>{certificateData.student_name}</h2>

          <p>has successfully completed internship as</p>

          <h3>{certificateData.intern_type}</h3>

          <p>Certificate Number: {certificateData.certificate_number}</p>

          <img src="/qr.png" width="100" alt="QR" />
        </div>
      )}
    </div>
  );
};

export default InternDashboard;
